import { Column, Row } from 'app/design/primitives/box';
import { createTheme as createDSTheme } from 'app/shopify';
import { Text } from 'app/design/primitives/text';
import type { UnavailabilityMessage as UnavailabilityMessageType } from 'app/types/chat';
import { isSystemMessage } from 'app/types/chat';
import { IconClock } from '@tabler/icons-react-native';
import { ICON_STROKE_WIDTH } from 'app/utils/constants';
const theme = createDSTheme();

interface UserMessageProps {
  message: UnavailabilityMessageType;
}

export function UnavailabilityMessage({ message }: UserMessageProps) {
  return (
    <Column alignItems="flex-end">
      <Column
        gap="spacing.general.x4"
        alignItems="center"
        borderRadius="radius.lg"
        padding="spacing.general.x8"
        style={{ backgroundColor: theme.colors['surface.primary-neutral'] }}
      >
        <Row borderRadius="radius.full" backgroundColor="text.secondary" padding="spacing.general.x1">
          <IconClock strokeWidth={ICON_STROKE_WIDTH} size={30} color="white" />
        </Row>
        <Text
          fontSize={16}
          selectable
          style={{ fontStyle: isSystemMessage(message) ? 'italic' : undefined }}
          variant="bodyBase"
          textAlign="center"
        >
          {typeof message.message === 'string' ? message.message : null}
        </Text>
      </Column>
    </Column>
  );
}
